package horcrux.frontend.common.views.navigation

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.State
import horcrux.frontend.common.configs.ApplicationConfigs
import horcrux.common.RenderingLocation
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.configs.StaticContentConfigs.CHROME_EXTENSION_URL
import horcrux.frontend.common.views.components.containers.HStack
import kotlinx.browser.window
import mui.material.Divider
import mui.material.IconButton
import mui.material.IconButtonColor
import mui.material.IconButtonEdge
import mui.material.Link
import mui.material.Menu
import mui.material.MenuItem
import mui.material.Size
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC
import react.Props
import react.PropsWithChildren
import react.dom.aria.ariaLabel
import react.dom.html.ReactHTML.div
import react.router.useNavigate
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.number
import web.cssom.px
import web.dom.Element
import mui.icons.material.Menu as MenuIcon

external interface NavigatorButtonProps : Props {
    var route: Route
    var globalAppState: GlobalAppState
}

val NavigatorButton = FC<NavigatorButtonProps> { props ->
    val anchorElementState = State<Element?>(null)
    val anchorElementMaybe = anchorElementState.get()
    val hideToolbar = { anchorElementState.reset() }
    val navigate = useNavigate()

    HStack {
        this.sx {
            this.display = Display.flex
            this.alignItems = AlignItems.center
            this.justifyContent = JustifyContent.flexStart
        }
        IconButton {
            sx {
                this.marginRight = 2.px
            }
            this.size = Size.large
            this.edge = IconButtonEdge.end
            this.color = IconButtonColor.inherit
            this.ariaLabel = "menu"
            MenuIcon {
                this.onClick = { anchorElementState.set(it.currentTarget) }
            }
            Menu {
                this.anchorEl = anchorElementMaybe?.let { { _ -> it } }
                this.open = anchorElementMaybe != null
                this.onClose = { hideToolbar() }
                LinkMenuItem {
                    +"Home"
                    this.href = ApplicationConfigs.FRONTEND_URL
                    this.onClick = {
                        hideToolbar()
                    }
                    this.onClickIfClientSideRenderMaybe = {
                        hideToolbar()
                        window.open(ApplicationConfigs.FRONTEND_URL, "_blank", "noreferrer")
                    }
                }
                for (route in listOf(
                    Route.CHAT_WITH_YOUR_COLLECTION,
                    Route.CONTACT_US,
                    Route.LATEST_NEWS,
                    Route.PRIVACY_POLICY,
                )) {
                    LinkMenuItem {
                        +"${route.viewName}"
                        this.href = route.fullURL
                        this.onClick = { hideToolbar() }
                        this.onClickIfClientSideRenderMaybe = { props.globalAppState.navigateTo(navigate, route) }
                    }
                }
                LinkMenuItem {
                    +"Download Chrome Extension"
                    this.href = CHROME_EXTENSION_URL
                    this.onClick = {
                        hideToolbar()
                        window.open(CHROME_EXTENSION_URL, "_blank", "noreferrer")
                    }
                }
                Divider {}
                MenuItem {
                    +"Sign Out"
                    this.onClick = {
                        props.globalAppState.signOut {
                            hideToolbar()
                        }
                    }
                }
            }
        }
        Typography {
            +"${props.route.viewName}"
            this.variant = TypographyVariant.h6
            this.component = div
            this.sx {
                this.flexGrow = number(1.0)
                this.flex = number(1.0)
            }
        }
    }
}

private external interface LinkMenuItemProps : PropsWithChildren {
    var href: String
    var onClick: () -> Unit
    var onClickIfClientSideRenderMaybe: (() -> Unit)?
}

private val LinkMenuItem = FC<LinkMenuItemProps> { props ->
    MenuItem {
        Link {
            +props.children
            this.sx {
                this.color = StaticContentConfigs.BLACK
                asDynamic().textDecoration = "none"
            }
            this.href = props.href
            this.onClick = { event ->
                props.onClick()
                if (ApplicationConfigs.RENDERING_LOCATION == RenderingLocation.CLIENT) {
                    props.onClickIfClientSideRenderMaybe?.let {
                        event.preventDefault()
                        it()
                    }
                }
            }
        }
    }
}
